import { configureStore, ThunkAction, Action, combineReducers, AnyAction } from '@reduxjs/toolkit'
import authReducer from './authslice'
import navigationReducer from './navigationslice'
import activityReducer from './activitySlice'
import previewActivityReducer from './previewActivitySlice'
import pageReducer from './pageSlice'
import settingsReducer from './settingsSlice'
import organisationReducer from './organisationSlice'
import searchReducer from './searchSlice'
import forgotPasswordReducer from './forgotpasswordslice'
import resetPasswordReducer from './resetpasswordslice'
import registrationRequestReducer from './registrationRequestSlice'

const combinedReducer = combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  activity: activityReducer,
  previewActivity: previewActivityReducer,
  page: pageReducer,
  settings: settingsReducer,
  organisation: organisationReducer,
  search: searchReducer,
  forgotpassword: forgotPasswordReducer,
  resetpassword: resetPasswordReducer,
  registrationRequest: registrationRequestReducer,
})

// Feel free to try to type rootReducer
//const rootReducer = (state: any, action: AnyAction) => {

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state: any, action: AnyAction) => {
  // if (action.type === 'app/reset' || action.type === logoutSuccess.type) {
  // if (action.type === 'app/reset') {
  //   state = undefined
  // }

  return combinedReducer(state, action)
}

export const store = configureStore({ reducer: rootReducer })

export type RootState = ReturnType<typeof store.getState>

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
export type AppDispatch = typeof store.dispatch
